(function () {
  function parseIdList(attr) {
    if (!attr) return [];
    return attr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function cartIntersects(cart, setA, setB) {
    if (!cart || !cart.items || !setA.length || !setB.length) return false;
    var hasA = false, hasB = false;
    for (var i = 0; i < cart.items.length; i++) {
      var pid = String(cart.items[i].product_id);
      if (setA.indexOf(pid) !== -1) hasA = true;
      if (setB.indexOf(pid) !== -1) hasB = true;
      if (hasA && hasB) return true;
    }
    return false;
  }

  function buildRules() {
    var modals = document.querySelectorAll('[data-compat-warning]');
    var rules = [];
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      var setA = parseIdList(m.getAttribute('data-products-a'));
      var setB = parseIdList(m.getAttribute('data-products-b'));
      if (!setA.length || !setB.length) continue;
      rules.push({
        modal: m,
        setA: setA,
        setB: setB,
        sessionKey: 'compatWarn:' + (m.getAttribute('data-block-id') || m.id)
      });
    }
    return rules;
  }

  function tryShow(rule, cart) {
    if (sessionStorage.getItem(rule.sessionKey) === '1') return;
    if (!cartIntersects(cart, rule.setA, rule.setB)) return;
    if (typeof rule.modal.show !== 'function') return;
    sessionStorage.setItem(rule.sessionKey, '1');
    rule.modal.show();
  }

  function evaluateAll(rules, cart) {
    for (var i = 0; i < rules.length; i++) tryShow(rules[i], cart);
  }

  function init() {
    var rules = buildRules();
    if (!rules.length) return;

    var allFired = rules.every(function (r) {
      return sessionStorage.getItem(r.sessionKey) === '1';
    });
    if (allFired) return;

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { evaluateAll(rules, cart); })
        .catch(function () {});
    }

    refresh();

    document.addEventListener('product-ajax:added', refresh);

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        evaluateAll(rules, payload && payload.cart);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
